/**
 * Ce qui est posé dans un ENCART : la lavande `surface-subtle` (sur la nuit, la marche au-dessus de la
 * carte), ou une tinte, posée dans une carte.
 *
 * Aucune tinte ne s'y détache : de 1,02 à 1,11:1, sur la nuit comme en clair, quand la marche du livre est
 * de 1,20. Une pastille teintée (`<Badge>` en tinte, donc `<GainChip>`, et `<IconBubble>`) y perd donc son
 * fond et garde son encre, qui s'y lit mieux que sur sa tinte (`pillFillOn`, Wajih 23/10). La règle tient à
 * ce qui porte la pastille, pas au thème : elle vaut en clair comme sur la nuit.
 *
 * `<Card>` le dit d'elle-même, selon son fond (`isInsetSurface`) ; une surface d'encart peinte à la main
 * (la bande de l'étape en cours du test du matériel) pose `<InsetContext.Provider value>`. Une carte posée
 * dans un encart redevient une carte. Sous l'aurore, l'encart n'est plus plat : la tinte s'en détache et
 * l'encre, posée à même l'aurore, ne s'y lirait pas — `<QuestCard>` remet le contexte à faux.
 */
import { createContext, useContext } from "react"

export const InsetContext = createContext(false)

/** Vrai dans un encart : une pastille teintée y pose son encre, sans fond. */
export function useOnInset(): boolean {
    return useContext(InsetContext)
}
